export default __webpack_public_path__ + "static/media/cookware_dark.9f983cf1.png";